import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import {axios, getParams} from "@/src/modules/core/lib";
import type {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";
import type {PermanentParkingPermitStatusBody} from "../schemas";
import type {PermanentParkingPermit} from "../types";

class PermanentParkingApi extends CoreApi {
  getPermits(
    options?: ParamsOptions,
  ): Promise<AxiosResponse<GetListResponse<PermanentParkingPermit>>> {
    const params = getParams(options);
    return axios({url: "permanent-parking-permits", method: "get", params});
  }

  getPermit(id: number): Promise<AxiosResponse<GetResponse<PermanentParkingPermit>>> {
    return this.getById("permanent-parking-permit", id);
  }

  updatePermitStatus(
    id: number,
    body: PermanentParkingPermitStatusBody,
  ): Promise<AxiosResponse<{data?: PermanentParkingPermit}>> {
    return this.post(`permanent-parking-permit/${id}/status`, body);
  }

  attachApplicationVehicleProof(
    taskId: number,
    applicationVehicleId: number,
    files: string[],
  ): Promise<AxiosResponse<{data?: unknown}>> {
    return this.post(
      `tasks/${taskId}/application-vehicles/${applicationVehicleId}/proof`,
      {files},
    );
  }

  reviewApplicationVehicleProof(
    taskId: number,
    applicationVehicleId: number,
    decision: "approve" | "reject",
    notes?: string,
  ): Promise<AxiosResponse<{data?: unknown}>> {
    return this.post(
      `tasks/${taskId}/application-vehicles/${applicationVehicleId}/proof-review`,
      {
        decision,
        ...(notes?.trim() ? {notes: notes.trim()} : {}),
      },
    );
  }
}

export const permanentParkingApi = new PermanentParkingApi();
